export default {
  '1': {
    type: '普通会员',
    list: [
      {title: '升级条件', con: [
        '注册管家账号即可马上升级成为高铁管家普通会员。',
        '普通会员期间随时可以升级为更高等会员。',
      ]},
      {title: '会员福利', con: [
        '升级成功后，通过高铁管家购买火车票，机票，酒店，汽车票，专车等开始累积活跃经验值喝积分，积分可用于兑换返现红包或其他礼品。',
        '升级为普通会员的用户将收到1元火车票红包一个（返现后可提现到支付宝）。设置生日后，还将在生日当天获得价值9元生日礼包一份（以生日当天的等级为准，1年内只发放一次）。'
      ]}
    ]
  },
  '2': {
    type: '白银会员',
    list: [
      {title: '升级条件', con: [
        '获得3000活跃经验值，且绑定高铁管家微信公众号，将立即升级为白银会员。',
        '升级成功后，会员等级将保留1个月，1个月以后将根据最近12个月内的活跃经验值重新评定。',
        '白银会员期间随时可以通过购票或购买行为升级为更高等会员。'
      ]},
      {title: '会员福利', con: [
        '生日礼物：设置生日后，还将在生日当天获得价值19元生日礼包一份（以生日当天的等级为准，1年内只发放一次）。',
        '抢票加速：白银用户还享受抢票1.2倍加速，抢票更容易。',
        '机票会员价：白银用户还享受部分机票直减优惠，最高每单减20元。',
        '提速宝：白银用户每月1日将自动发放提速宝1个（可用于抢票时抵扣套餐费用）。',
        '延误宝：白银用户每月1日将自动发放延误宝1个（列车延误半小时立赔5元，1小时立赔10元）。'
      ]}
    ]
  },
  '3': {
    type: '黄金会员',
    list: [
      {title: '升级条件', con: [
        '获得10000活跃经验值，将立即升级为黄金会员。',
        '升级成功后，会员等级将保留1个月，1个月以后将根据最近12个月的经验值重新评定。',
        '黄金会员期间随时通过购票或购买行为升级为更高等会员。'
      ]},
      {title: '会员福利', con: [
        '生日礼物：设置生日后，还将在生日当天获得价值29元生日礼包一份（以生日当天的等级为准，1年内只发放一次）。',
        '抢票提速：黄金用户享受抢票1.5倍加速，抢票更容易。',
        '机票会员价：黄金用户享受部分机票直减优惠，最高每单减70元。',
        '提速宝：每月1日将自动发放提速宝2个（可用于抢票时抵扣套餐费用）。',
        '延误宝：每月1日将自动发放延误宝2个（列车延误半小时奖励5元，1小时奖励10元）。'
      ]},
      {title: '支持购买', con: [
        '为了让更多的用户可以直接享受高等级权益，高铁管家黄金会员支持直接购买升级，黄金会员售价为49元/年。',
        '购买升级成为黄金会员的用户，会赠送总价值200元的黄金大礼包一个，包含顶级抢票券5张。',
        '购买成功后立即生效，有效期1年，且1年内不允许重复购买，权益一经使用，不支持退款。',
        '有效期内如将顶级抢票券全部使用，可以购买更高等级的会员或购买高铁抢票卡，继续享受低价高抢票速度的服务。'
      ]}
    ]
  },
  '4': {
    type: '白金会员',
    list: [
      {title: '升级条件', con: [
        '获得30000活跃经验值，将立即升级为白金会员。',
        '升级成功后，会员等级将保留1个月，1个月以后将根据最近12个月的经验值重新评定。',
        '白金会员期间随时通过购票或购买行为升级为更高等会员。'
      ]},
      {title: '会员福利', con: [
        '生日礼物：升级为白金会员的用户设置生日后，将在生日当天获得价值49元生日礼包一份（以生日当天的等级为准，1年内只发放一次）。',
        '抢票提速：白金用户还享受抢票1.8倍加速，抢票更容易。',
        '机票会员价：白金用户还享受部分机票直减优惠，最高每单减120元。',
        '提速宝：白金用户还将在每月收到提速宝15个，可用于抵扣抢票套餐。',
        '延误宝：白金用户还将在每月收到延误宝3个（价值2元），乘车延误半小时立赔5元，延误1小时，赔偿10元。',
        '专车半价：白金用户1年内可以兑换专车半价优惠券2次（最高免200元）需10000积分兑换。',
        '专车免单：白金用户1年内可以兑换专车免单优惠券1次（最高免200元）需100000积分兑换。'
      ]},
      {title: '支持购买', con: [
        '为了让更多的用户可以直接享受高等级权益，高铁管家白金会员支持直接购买升级，白金会员售价为99元/年。',
        '购买白金会员的用户可以选择常旅客礼包或抢票礼包任意一个，选择常旅客礼包的用户：跟本人（需绑定身份证）购票时可享受：购买火车票首单立返20元（出票成功后返现），并在有效期内享受每单返现8元优惠（火车票价格>=11，每月最多享受5次，乘车后返现）有效期内总返现次数12次（不含首次），最终可得116元。返现金额将充值到您的管家余额（可提现到支付宝）可用于app内任何消费，支付时选择余额支付即可。',
        '有效期内如已全部返现，可以购买更高等级的会员，继续享受常旅客超值返现服务。暂不支持重复购买。',
        '选择抢票礼包的用户，送顶级抢票券10张。价值400元。',
        '有效期内如将顶级抢票券全部使用，可以购买更高等级的会员或购买高铁抢票卡，继续享受低价高抢票速度的服务。',
        '购买成功后立即生效，有效期1年，且1年内不允许重复购买，权益一经使用，不支持退款。'
      ]}
    ]
  },
  '5': {
    type: '钻石会员',
    list: [
      {title: '升级条件', con: [
        '获得100000活跃经验值，将立即升级为钻石会员。',
        '升级成功后，会员等级将保留1个月，1个月以后将根据最近12个月的经验值重新评定。',
      ]},
      {title: '会员福利', con: [
        '生日礼物：设置生日后，还将在生日当天获得价值99元生日礼包一份（以生日当天的等级为准，1年内只发放一次）。',
        '抢票提速：钻石用户还享受抢票2.0倍加速，抢票更容易。',
        '机票会员价：钻石用户还享受部分机票直减优惠，最高每单减70元。',
        '提速宝：钻石用户还将在每月1号自动发放提速宝20个，可用于抵扣抢票套餐。',
        '延误宝：钻石用户还将在每月1号收到延误宝5个，可用于5次出行使用，乘车延误半小时立赔5元，延误1小时，立赔10元。',
        '专车半价：钻石用户在有效期内可兑换专车半价优惠券2次（单次最高免100元）需10000积分兑换。',
        '专车免单：钻石用户在有效期内可兑换专车免单优惠券1次（单次最高免200元）需50000积分兑换。',
        '专属客服：客服将在第一时间处理您的问题。'
      ]},
      {title: '支持购买', con: [
        '为了让更多的用户可以直接享受高等级权益，高铁管家钻石会员支持直接购买升级，钻石会员售价为199元/年。',
        '购买钻石会员的用户可以选择常旅客礼包或抢票礼包任意一个，选择常旅客礼包的用户：跟本人（需绑定身份证）购票时可享受：购买火车票首单立返50元（出票成功后返现），并在有效期内享受每单返现10元优惠（火车票价格>=11，每月最多享受5次，乘车后返现）有效期内总返现次数19次（不含首次），最终可得240元。返现金额将充值到您的管家余额（可提现到支付宝）可用于app内任何消费，支付时选择余额支付即可。',
        '有效期内如已全部返现，可以购买更高等级的会员，继续享受常旅客超值返现服务。',
        '选择抢票礼包的用户，送顶级抢票券15张。价值600元。',
        '有效期内如将顶级抢票券全部使用，可以购买更高等级的会员或购买高铁抢票卡，继续享受低价高抢票速度的服务。',
        '购买成功后立即生效，有效期1年，且1年内不允许重复购买，权益一经使用，不支持退款。'
      ]}
    ]
  }
}


// WEBPACK FOOTER //
// ./src/DATA/vipExplain.js